import get from 'lodash/get';
import { Team, User } from 'api/models';
import {
  DEFAULT_OPTION_MODEL,
  ID_TYPE_SEPARATOR,
  OPTION_KEYS,
} from './followers.constants';
import { Option, Value, OptionType, SelectedData } from './followers.interface';

export const getOptionValue = (
  value: User | Team,
  key: string,
  type: string,
): string | number | undefined => get(value, OPTION_KEYS[type][key]);

export const constructOption = (
  value: User | Team,
  type: OptionType,
): Option => {
  const option: Option = {
    value: '',
    type,
    id: 0,
  };

  Object.keys(DEFAULT_OPTION_MODEL).forEach((key) => {
    option[key] = getOptionValue(value, key, type);
  });
  option.value = [option.type, option.id].join(ID_TYPE_SEPARATOR);

  return option;
};

export const constructSelectOptions = (options: Value): Array<Option> => {
  let opts: Array<Option> = [];

  Object.keys(options).forEach((key) => {
    opts = [
      ...opts,
      ...options[key].map((o) => constructOption(o, key as OptionType)),
    ];
  });

  return opts;
};

export const getSelectedValues = (value: Value): string[] => {
  let values: string[] = [];

  Object.keys(value).forEach((key) => {
    values = [
      ...values,
      ...value[key].map(
        (o) => `${key}${ID_TYPE_SEPARATOR}${getOptionValue(o, 'id', key)}`,
      ),
    ];
  });

  return values;
};

export const getIdAndTypFromValue = (value: string): [number, OptionType] => {
  const [type, id] = value.split(ID_TYPE_SEPARATOR);

  return [Number(id), type];
};

export const convertSelectedValuesToApiPayload = (
  arr: string[] | string,
  types: string[],
): SelectedData => {
  const payload = types.reduce((o, s) => {
    const object = { ...o };

    object[s] = [];

    return object;
  }, {});
  const constructPayload = (v) => {
    const [id, type] = getIdAndTypFromValue(v);
    const key = OPTION_KEYS[type].id;
    const object = {};

    object[key] = id;
    payload[type] = [...payload[type], object];
  };

  if (Array.isArray(arr)) {
    arr.forEach((v) => {
      constructPayload(v);
    });
  } else {
    constructPayload(arr);
  }

  return payload;
};

export const getSelectedOptions = (
  selectedValues: string[],
  options: Option[],
) => options.filter((o) => selectedValues.includes(o.value));
